module.exports = __webpack_public_path__ + "fonts/fontello.6700063a.eot";